import styled, { css } from "styled-components/macro";

import type { ThemeProps } from "models/styles/theme";

import { CssFlex, CssIcon } from "styles/helpers/layout";

export type NoteVariant = "info" | "error" | "success" | "warning";

interface Props extends ThemeProps {
  $variant: NoteVariant;
}

export const StyledNote = styled(CssFlex)<Props>`
  padding: 0.5rem 1rem;
  align-items: center;
  gap: 0.5rem;

  ${(props: Props) => {
    switch (props.$variant) {
      case "success":
        return css`
          background: ${(props: Props) => props.theme.palette.feedback.success._950};
          border-left: solid 2px ${(props: Props) => props.theme.palette.feedback.success.brand};
          ${CssIcon} { color: ${(props: Props) => props.theme.palette.feedback.success.brand}; }
        `;
      case "error":
        return css`
          background: ${(props: Props) => props.theme.palette.feedback.error._950};
          border-left: solid 2px ${(props: Props) => props.theme.palette.feedback.error.brand};
          ${CssIcon} { color: ${(props: Props) => props.theme.palette.feedback.error.brand}; }
        `;
      case "warning":
        return css`
          background: ${(props: Props) => props.theme.palette.yellow._999};
          border-left: solid 2px ${(props: Props) => props.theme.palette.yellow.brand};
          ${CssIcon} { color: ${(props: Props) => props.theme.palette.yellow.brand}; }
        `;
      default:
        return css`
          background: ${(props: Props) => props.theme.palette.feedback.info._999};
          border-left: solid 2px ${(props: Props) => props.theme.palette.feedback.info.brand};
          ${CssIcon} { color: ${(props: Props) => props.theme.palette.feedback.info.brand}; }
        `;
    }
  }}
`;
